<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>

<div class="modal-body">
  <div>
    <ng-select [(ngModel)]="reason"
               [items]="reasonOptions"
               [multiple]="false"
               bindLabel="name"
               bindValue="code"
               class="form-control wd-500px mb-8px"
               placeholder="Reason"
               required="true">
    </ng-select>

  </div>
  <div class="d-flex">
    <textarea [(ngModel)]="comment" aria-multiline="true" rows="5"></textarea>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end w-100">
    <button (click)="reject()" class="btn btn-185px btn-dark" type="button">
      Confirm
    </button>
  </div>
</div>

